window.TalentPoolAPI2 = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    self.TYPES = {
        LOCAL_TAG: 'LOCAL',
        GLOBAL_TAG: 'GLOBAL',
        GENERAL_TAG: 'GENERAL',
        STATUS_TAG: 'STATUS',
        POSITION_TAG: 'POSITION',
    };

    self.TAGS_TYPES = {
        LOCAL: 'LOCAL',
        PRIVATE: 'PRIVATE',
        GLOBAL: 'GLOBAL',
        GENERAL: 'GENERAL',
        STATUS: 'STATUS',
        POSITION: 'POSITION'
    };

    self.TAGS_TYPES_TO_TEXT = {
        LOCAL: 'Local Tags',
        PRIVATE: 'Private Tags',
        GLOBAL: 'Global Tags',
        GENERAL: 'General Tags',
        STATUS: 'Status Tags',
        POSITION: 'Position Tags',
    };

    self.STATUS_TAGS_NAMES = {
        'Referral': 'Referral',
        'Applied to Talent Pool': 'Applied to Talent Pool',
        'New Hire': 'New Hire',
        'Employee': 'Employee',
        'Previous Employee': 'Previous Employee',
        'No Show': 'No Show',
        'Talent scout': 'Talent scout',
        'Non-Employee': 'Non-Employee'
    }

    _protected.setApiUrl(publicConfiguration['TalentPoolServer']);

    self.getBrandTalentPoolSettings = cacheService.cache(function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    })[0];

    self.getUserTalentScoutCode = (brandId, userId) => {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/users/${userId}/talent_scout`, 'GET')
            .then((res) => {

                if (res?.data?.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, (err) => {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.regenerateUserTalentScoutCode = async (brandId, userId) => {
        const response = await _protected.request(`brands/${brandId}/users/${userId}/talent_scout/regenerate`, 'POST');

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getSilverMedalistStageTagOptions = async (brandId,category) => {

        if (!brandId) {
            throw "No brand id";
        }

        const response = await _protected.request(`brands/${brandId}/tag_options?category=${category}`, 'GET');
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;

    };

    self.getTalentScoutManagerDetails = async (brandId, userId, params) => {
        const response = await _protected.request(`brands/${brandId}/users/${userId}/talent_scout_details`, 'GET', params);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.updateAutomaticTagsDelayDays = async (brandId, payloadData) => {
        const response = await _protected.request(`brands/${brandId}/settings`, 'PATCH', payloadData);

        if (response?.data?.data  && response.status === 200) {
            return response.data.data;
        }

        throw response;
    };

    self.validateTalentPoolCandidate = async (brandId, payload) => {
        const response = await _protected.request(`brands/${brandId}/talent_pools/validate_user`, 'POST', payload);

        if (response?.data?.data  && response.status === 200) {
            return response.data.data;
        }

        throw response;
    };

    self.addCandidateToTalentPool = async (brandId, payload) => {
        const response = await _protected.request(`brands/${brandId}/talent_pools/users`, 'POST', payload);

        if (response?.data?.data  && response.status === 200) {
            return response.data.data;
        }

        throw response;
    };

    self.getBrandTags = function (brandId, payload) {

        if (!brandId) {
            throw "No brand id";
        }

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/tags', 'GET', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.deleteTag = function (brandId, tagId) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!tagId) {
            throw "No tag id";
        }

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/tags/' + tagId, 'DELETE')
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.checkTagName = function (brandId, payload) {

        if (!brandId) {
            throw "No brand id";
        }

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/tags/name_check', 'GET', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.createTag = async (brandId, payload, candidateId) => {

        if (!brandId) {
            throw "No brand id";
        }

        let defer = $q.defer();
        try {
            if (candidateId) {
                const data = await BrandAPI.checkEmployerProfileTypeStatus(brandId, candidateId);
                for (let user of data) {
                    const {profile_type, has_localized_profile_on_business} = user;
                    if (
                        (profile_type === BrandAPI.PROFILE_TYPES.MARKETPLACE && has_localized_profile_on_business) ||
                        (profile_type === BrandAPI.PROFILE_TYPES.LOCALIZED && !has_localized_profile_on_business)
                    ) {
                        throw new Error(BrandAPI.PROFILE_TYPES_ERROR_CODES.CANNOT_APPLY);
                    }
                }
            }

            _protected.request('brands/' + brandId + '/tags', 'POST', payload)
                .then(function (res) {
                    if (res?.status === 200 && res?.data) {
                        defer.resolve(res.data.data);
                    } else {
                        defer.reject(res.data);
                    }
                })
                .catch(function (err) {
                    defer.reject(err);
                });
        } catch (err) {
            throw err;
        }
        return defer.promise;
    };

    self.updateTag = function (brandId, tagId, payload) {

        if (!brandId) {
            throw "No brand id";
        }

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/tags/' + tagId, 'PUT', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.applyTagsOrder = async (brandId, tagsType, payload) => {
        const params = {
            brand_tags: payload
        }
        const res = await _protected.request(`brands/${brandId}/tag_modes/${tagsType}/order`, 'PUT', params);
        if (res?.data?.data  && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };


    self.getCandidatesTags = function(brandId, ids, onlyTagsId, tagMode, amsFlow){


        if (!brandId) {
            throw "No brand id";
        }


        if (_.isEmpty(ids)) {
            throw "No candidates ids";
        }

        var payload = {}, defer = $q.defer();
        onlyTagsId = onlyTagsId || false;

        if (tagMode) {
            payload.tag_modes = tagMode;
        }

        if (amsFlow) {
            payload.ams_flow = amsFlow;
        }

        if (onlyTagsId) {
            payload.only_tag_id = true;
        }

        payload.ids = ids || [];

        _protected.request('brands/' + brandId + '/candidates/tags', 'GET', payload).then(function (res) {
            if (res && res.status === 200 && res.data) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res.data);
            }
        }).catch(function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.validateUser = cacheService.cache(async (brandId, payload) => {
        try {
            const res = await _protected.request(`brands/${brandId}/talent_pools/validate_user`, 'POST', payload);
            if (res?.status === 200 && res?.data?.data) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (error) {
            throw err;
        }
    })[0]

    self.assignTagsToCandidates = async (brandId, payload) => {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (_.isEmpty(payload.candidate_ids)) {
            throw "No candidates ids";
        }

        if (_.isEmpty(payload.tag_ids)) {
            throw "No tags ids";
        }
        try {
            const data = await BrandAPI.checkEmployerProfileTypeStatus(brandId, payload.candidate_ids);
            for (let user of data) {
                const {profile_type, has_localized_profile_on_business} = user;
                if (
                    (profile_type === BrandAPI.PROFILE_TYPES.MARKETPLACE && has_localized_profile_on_business) ||
                    (profile_type === BrandAPI.PROFILE_TYPES.LOCALIZED && !has_localized_profile_on_business)
                ) {
                    throw new Error(BrandAPI.PROFILE_TYPES_ERROR_CODES.CANNOT_APPLY);
                }
            }


        _protected.request('brands/' + brandId + '/candidates/tags/assign', 'POST', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            }).catch(function (err) {
            defer.reject(err);
        });
        } catch (err) {
            throw err;
        }
        return defer.promise;
    };

    self.checkIfExists = function(brandId, candidateId){
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!candidateId) {
            throw "No candidateId";
        }

        _protected.request('brands/' + brandId + '/candidates/' + candidateId, 'GET').then(function (res) {
            if (res && res.status === 200 && res.data) {
                defer.resolve(Object.keys(res.data.data).length > 0);
            } else {
                defer.resolve(res.data);
            }
        }).catch(function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.unassignTagsToCandidates = function(brandId, payload){
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (_.isEmpty(payload.candidate_ids)) {
            throw "No candidates ids";
        }

        if (_.isEmpty(payload.tag_ids)) {
            throw "No tags ids";
        }

        _protected.request('brands/' + brandId + '/candidates/tags/unassign', 'POST', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            }).catch(function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.unassignAllTagsToCandidates = function(brandId, payload){
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (_.isEmpty(payload.candidate_ids)) {
            throw "No candidates ids";
        }

        _protected.request('brands/' + brandId + '/candidates/tags/unassign', 'POST', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            }).catch(function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.search = function (brandId, params) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/talent_pools/candidates/search', 'POST', params)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.removeCandidatesFromPool = function (brandId, candidateIds) {
        var defer = $q.defer();

        var params = {
            candidate_ids: candidateIds
        };

        _protected.request('brands/' + brandId + '/talent_pools/candidates/remove', 'POST', params)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.updateTagPositionFeedback = async (brandId, tagId, candidateId, thumpType, note) => {
        const params = {
            thump_type: thumpType,
            note: note || ''
        };

        try {
            const response = await _protected.request(`brands/${brandId}/tags/${tagId}/candidates/${candidateId}/feedback`, 'POST', params);
            if (response.data && response.data.data && response.status === 200) {
                return response.data.data;
            } else {
                throw response;
            }
        } catch (err) {
            throw err;
        }
    };

    self.loadUserPreferences = async function() {
        try {
            const res = await _protected.request('user_preferences', 'GET');
            if (res?.status === 200 && res?.data) {
                return res.data.data;
            } else {
                return res.data;
            }
        } catch (err) {
            throw err;
        }
    };

    self.saveUserPreferences = async function(advancedTalentPoolFilteringStatus) {
        const payload = {
            settings: {
                advanced_talent_pool_filtering_enabled: advancedTalentPoolFilteringStatus
            }
        };

        try {
            const res = await _protected.request('user_preferences', 'PUT', payload);
            if (res?.status === 200 && res?.data) {
                return res.data.data;
            } else {
                return res.data;
            }
        } catch (err) {
            throw err;
        }
    };

    self.validateShortListedCandidates = cacheService.cache(async (brandId, payload) => {
        const response = await _protected.request(`brands/${brandId}/talent_pools/validate_users`, 'POST', payload);

        if (response?.data?.data  && response.status === 200) {
            return response.data.data;
        }

        throw response;
    })[0];

    self.getCandidateTalentPoolBrands = async () => {
        const response = await _protected.request(`candidate/talent_pool/brands`, 'GET');

        if (response?.data?.data  && response.status === 200) {
            return response.data.data;
        }

        throw response;
    };

    self.updateTalentPoolBrandOptSettings = async (brandId, candidateId, status) => {
        const response = await _protected.request(`brands/${brandId}/candidates/${candidateId}/${status}`, 'POST');

        if (response?.data?.data  && response.status === 200) {
            return response.data.data;
        }

        throw response;
    };

    self.getTalentPoolAdvancedFilters = async (brandId) => {
        try {
            const res = await _protected.request(`brands/${brandId}/users/filters`, 'GET');
            if (res?.status === 200 && res?.data?.data) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    }

    self.getTalentPoolAdvancedFilterById = async (filterId) => {
        try {
            const res = await _protected.request(`filters/${filterId}`, 'GET');
            if (res?.status === 200 && res?.data?.data) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    }

    self.saveAdvancedFilter = async (brandId, payload) => {
        try {
            const res = await _protected.request(`brands/${brandId}/filters`, 'POST', payload);
            if (res?.status === 200 && res?.data?.data) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    }

    self.deleteAdvancedFilter = async (filterId) => {
        try {
            const res = await _protected.request(`filters/${filterId}`, 'DELETE');
            if (res?.status === 200 && res?.data?.data) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    }

    self.updateAdvancedFilter = async (filterId, payload) => {
        try {
            const res = await _protected.request(`filters/${filterId}`, 'PUT', payload);
            if (res?.status === 200 && res?.data?.data) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    }

    self.renameAdvancedFilter = async (filterId, payload) => {
        try {
            const res = await _protected.request(`filters/${filterId}/rename`, 'PUT', payload);
            if (res?.status === 200 && res?.data?.data) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    }

    self.validateAdvancedFilterName = async (payload) => {
        try {
            const res = await _protected.request('users/filters/validate', 'POST', payload);
            if (res?.status === 200 && res?.data?.data) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    }
});
